const textList = [
  '',
  '2013年2月21日，港珠澳大桥桥梁工程首件混凝土预制墩台完成整体预制。',
  '2013年2月22日，桥梁工程首个承台墩身在项目部中山基地预制完成。',
  '2013年4月11日晚，港珠澳大桥珠澳口岸连接桥第一个承台钢管复合桩钢桩插打成功。',
  '2013年6月3日，港珠澳大桥首个承台墩身整体顺利安装到位。',
  '2013年6月20日上午12时，港珠澳大桥首个整体埋置式墩台成功安装。',
  '2013年8月26日，港珠澳大桥桥梁工程首个围堰下放到位。',
  '2014年10月8日,桥梁工程13个中间节墩身全部预制完成。',
  '2014年10月18日，桥梁工程承台墩身预制工程圆满完成。',
  '2014年12月14日下午，桥梁工程CB03标桩基施工全部完成。',
  '2015年1月16日，桥梁工程非通航孔桥承台墩身全部安装完成。',
  '2015年9月6日，桥梁工程完成最后一件上节墩身安装，主体工程220座墩台全线完工。',
]

const PierAlbum = textList.map((text, index) => {
  return {
    url: require(`../img/album/pier/${index}.jpg`),
    text,
  }
})

export default PierAlbum
